import styled from 'styled-components';

import { spacing } from '_utils/props';
import { heading_xs, svg } from '_utils/styles/';

export const ItemHeading = styled.h3`
  ${heading_xs}
  color: ${({ theme }) => theme.colors.element.quaternary};
  ${({ theme }) => spacing({ theme, $mt: 1 })};
`;

export const ItemDescription = styled.div`
  ${({ theme }) => spacing({ theme, $mt: 1 })};
  color: ${({ theme }) => theme.colors.element.primary};

  p,
  a {
    color: inherit;
    margin: 0;
  }
`;

export const IconWrapper = styled.div`
  ${svg(22, 22)}
  width: 22px;
  display: flex;

  path {
    fill: ${({ theme }) => theme.colors.element.secondary};
  }
`;
